const loadImage = async (url: string) => {
    await new Promise<void>(resolve => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve();
        img.onerror = () => resolve();
    });
}

const downloadImage = async (url: string) => {
    const createdUrl = await new Promise<string | null>(async resolve => {
        try {
            const response = await fetch(url, {
                cache: 'no-cache'
            });
            const blob = await response.blob();

            const createdUrl = URL.createObjectURL(blob);
            await loadImage(createdUrl);
            resolve(createdUrl);
        } catch {
            resolve(null);
        }
    });

    return createdUrl || url;
}

export { loadImage, downloadImage };